import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRepository } from '../../Common/Data/base.repository';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CapRuleRepository extends BaseRepository{
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getList(searchModel: Core.SearchModel<Core.CapRulePropertyEnum>): Observable<Compliance.QueryResultModel<Core.CapRuleModel>> {
        return this.httpPost(`/api/capRule/list`, searchModel);
    }

    getPredefinedCapRules(): Observable<Core.CapRulePredefinedModel[]> {
        return this.httpGet(`/api/capRule/predefinedCapRules`);
    }

    create(model: Core.CapRuleModel): Observable<Core.CapRuleModel> {
        return this.httpPost(`/api/capRule/create`, model);
    }

    update(model: Core.CapRuleModel): Observable<Core.CapRuleModel> {
        return this.httpPut(`/api/capRule/update`, model);
    }

    canBeDeleted(capRuleId: number): Observable<boolean>{
        return this.httpGet(`/api/capRule/${capRuleId}/canBeDeleted`);
    }

    delete(capRuleId: number): Observable<void> {
        return this.httpDelete(`/api/capRule/${capRuleId}`);
    }

    recalculateCapComponents(capRuleId: number): Observable<void>
    {
        return this.httpPost(`/api/capRule/${capRuleId}/recalculateCapComponents`, null);
    }
}
